import { Component, effect, ElementRef, input, Signal, signal, viewChild, WritableSignal } from "@angular/core";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

@Component({
  selector: 'wf-alert',
  standalone: true,
  imports: [
    FontAwesomeModule,
  ],
  styleUrl: 'alert.component.css',
  template: `
    <div class="alert alert-{{ level() }}" [attr.role]="controlledBy() ? 'alert' : undefined">
      <div class="alert-content">
        <ng-content/>
      </div>
      @if (controlledBy()) {
        <button
          class="dismiss-button"
          #dismissButton
          (click)="dismiss()"
          aria-label="Dismiss alert"
        >
          <fa-icon [icon]="closeIcon"/>
        </button>
      }
    </div>
  `,
})
export class AlertComponent {
  // If passed in, will make alert a dynamic alert that has role='alert' and can be dismissed
  // This is supposed to be the signal of the @if conditional that conditionally shows this alert in the consuming component
  readonly controlledBy = input<WritableSignal<boolean>>();

  readonly level = input<"info" | "warning" | "danger">("info");


  protected closeIcon = faXmark;

  protected readonly dismissButton = viewChild<ElementRef<HTMLButtonElement>>('dismissButton');
  protected readonly dissmissButtonFocusEffect = effect(
    () => {
      const button = this.dismissButton();
      // whenever the button appears in the dom it should be focused
      if (button) {
        button.nativeElement.focus();
      }
    }
  );

  dismiss() {
    this.controlledBy()?.set(false);
  }
}
